export default __webpack_public_path__ + "static/video-2ed6af555e084ff66525a6d4433b0732.webm";